// import { useEffect, useRef } from "react";

// const DevToolsPasswordGuard = ({ devToolsPassword }) => {
//   const accessGranted = useRef(false);
//   const alreadyPrompted = useRef(false);

//   useEffect(() => {
//     // Skip detection on mobile devices
//     const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
//     if (isMobile) return;

//     const detectDevTools = () => {
//       const threshold = 200; // pixels difference means DevTools likely open
//       const widthDiff = window.outerWidth - window.innerWidth;
//       const heightDiff = window.outerHeight - window.innerHeight;

//       const devToolsOpen = widthDiff > threshold || heightDiff > threshold;

//       if (devToolsOpen && !accessGranted.current && !alreadyPrompted.current) {
//         alreadyPrompted.current = true;

//         const input = prompt("🔒 Enter password to access DevTools:");
//         if (input !== devToolsPassword) {
//           alert("❌ Wrong password. Redirecting...");
//           window.location.href = "https://www.google.com";
//         } else {
//           accessGranted.current = true;
//         }
//       }
//     };

//     // Check continuously
//     const interval = setInterval(detectDevTools, 1000);

//     // Also trigger on resize (when DevTools docks)
//     window.addEventListener("resize", detectDevTools);

//     return () => {
//       clearInterval(interval);
//       window.removeEventListener("resize", detectDevTools);
//     };
//   }, [devToolsPassword]);

//   return null;
// };

// export default DevToolsPasswordGuard;
